import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Kmh from "../axes/Kmh";

let WeatherWindSpeed = {
    type: "line",
    label: "Wind Speed",
    fill: false,
    lineTension: 0,
    colorPalette: 15,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Kmh,
    xAxis:Time
};

export default WeatherWindSpeed;



// WEBPACK FOOTER //
// ./src/components/chart/channels/WeatherWindSpeed.js